/*
 * A random, persistent id for this browser. The server binds each admin
 * session to it, so a copied session cookie cannot be used from another
 * browser. It is not a fingerprint and holds no personal data.
 */
const DEVICE_ID_KEY = "gw_device_id";

let memoryDeviceId = null;

const createUuid = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();

  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));
  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex
    .slice(6, 8)
    .join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
};

export const getDeviceId = () => {
  try {
    let deviceId = window.localStorage.getItem(DEVICE_ID_KEY);

    if (!deviceId) {
      deviceId = createUuid();
      window.localStorage.setItem(DEVICE_ID_KEY, deviceId);
    }

    return deviceId;
  } catch {
    memoryDeviceId = memoryDeviceId || createUuid();
    return memoryDeviceId;
  }
};

// Removes the token stored by the previous login system.
export const clearLegacyTokens = () => {
  try {
    window.localStorage.removeItem("accessToken");
  } catch {
    // Nothing to clear.
  }
};
